import { render } from "./ArrowIcon.vue?vue&type=template&id=6b5695af"
import script from "./ArrowIcon.vue?vue&type=script&lang=js"
export * from "./ArrowIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/scripts/view/publicPages/icons/ArrowIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6b5695af"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6b5695af', __exports__)) {
    api.reload('6b5695af', __exports__)
  }
  
  module.hot.accept("./ArrowIcon.vue?vue&type=template&id=6b5695af", () => {
    api.rerender('6b5695af', render)
  })

}


export default __exports__